// extracted by mini-css-extract-plugin
export default {"settingsForm":"SettingsForm_settingsForm__B6vU8","inputsBlock":"SettingsForm_inputsBlock__3kwhu","input":"SettingsForm_input__t8E0P"};